const MODEL_NAME = 'channelPage'
export default [
  {
    path: `/${MODEL_NAME}/channelCoupon`,
    name: 'channelCoupon',
    component: () =>
      import(/* webpackChunkName: "channel-coupon" */ '@pages/channelPage/channelCoupon/index.vue')
  }
]
